import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBrands } from "src/redux/actions/brand.action";
import { getDepts } from "src/redux/actions/department.action";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import SearchIcon from "@material-ui/icons/Search";
import { getYearList } from "src/redux/actions/purchaseRequest.action";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    lineHeight: "5ch",
    alignContent: "center",
    minWidth: "20ch",
  },
}));

export default function BudgetCodeSearchFormComponent({ onSubmit }) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const brandReducer = useSelector((state) => state.brandReducer);
  const departmentReducer = useSelector((state) => state.departmentReducer);
  const { years } = useSelector((state) => state.purchaseRequestReducer);
  const {
    result: { companyid, countryid, secureid },
  } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    dispatch(getBrands(countryid, companyid, secureid));
    dispatch(getYearList());

    return () => {};
  }, []);

  if (
    brandReducer.isRejected ||
    departmentReducer.isRejected ||
    years.isRejected
  ) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        This is an error alert —{" "}
        <strong>Get year, brand and deparment !</strong>
      </Alert>
    );
  }

  const renderYear = () => {
    if (years.isLoading) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return years.data.map((item) => (
      <MenuItem MenuItem={item.YEAR_CODE} value={item.YEAR_CODE}>
        {item.YEAR_CODE}
      </MenuItem>
    ));
  };

  const renderBrandItem = () => {
    if (brandReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return brandReducer.result.map((item) => (
      <MenuItem key={item.ORG_BRAND_ID} value={item.ORG_BRAND_ID}>
        {item.BRAND}
      </MenuItem>
    ));
  };

  const renderDepartment = () => {
    if (departmentReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return departmentReducer.result.map((item) => (
      <MenuItem
        MenuItem={item.ORG_DEPARTMENT_ID}
        value={item.ORG_DEPARTMENT_ID}
      >
        {item.department}
      </MenuItem>
    ));
  };

  const handleChangeBrand = (event) => {
    dispatch(getDepts(countryid, companyid, secureid, event.target.value));
  };

  return (
    <div className={classes.modal}>
      <Formik
        initialValues={{
          PR_YEAR: "",
          PR_BRANDID: "",
          PR_DEPARTID: "",
          PR_COUNTRYID: countryid,
          PR_COMPANYID: companyid,
        }}
        validate={(values) => {
          const errors = {};

          if (!values.PR_YEAR) {
            errors.PR_YEAR = "Required";
          }

          if (!values.PR_BRANDID) {
            errors.PR_BRANDID = "Required";
          }

          if (!values.PR_DEPARTID) {
            errors.PR_DEPARTID = "Required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          // search
          onSubmit(values);
          setSubmitting(false);
        }}
        render={({
          submitForm,
          resetForm,
          isSubmitting,
          setSubmitting,
          touched,
          errors,
          values,
          setFieldValue,
        }) => (
          <>
            <Grid container spacing={1}>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    error={Boolean(
                      errors.PR_YEAR && touched.PR_YEAR && errors.PR_YEAR
                    )}
                    id="select-year-label"
                  >
                    BUDGET YEAR
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_YEAR"
                    label="Year"
                    labelId="select-year-label"
                    size="small"
                    error={Boolean(
                      errors.PR_YEAR && touched.PR_YEAR && errors.PR_YEAR
                    )}
                    onChange={() => {}}
                  >
                    {renderYear()}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    id="select-brand-label"
                    error={Boolean(
                      errors.PR_BRANDID &&
                        touched.PR_BRANDID &&
                        errors.PR_BRANDID
                    )}
                  >
                    BRAND
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_BRANDID"
                    label="Brand"
                    labelId="select-brand-label"
                    size="small"
                    error={Boolean(
                      errors.PR_BRANDID &&
                        touched.PR_BRANDID &&
                        errors.PR_BRANDID
                    )}
                    onChange={handleChangeBrand}
                  >
                    {renderBrandItem()}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth>
                  <InputLabel
                    error={Boolean(
                      errors.PR_DEPARTID &&
                        touched.PR_DEPARTID &&
                        errors.PR_DEPARTID
                    )}
                    id="select-depart-label"
                  >
                    DEPARTMENT
                  </InputLabel>
                  <Field
                    component={CustomSelectInput}
                    name="PR_DEPARTID"
                    label="Department"
                    labelId="select-depart-label"
                    size="small"
                    onChange={(e) => {}}
                    error={Boolean(
                      errors.PR_DEPARTID &&
                        touched.PR_DEPARTID &&
                        errors.PR_DEPARTID
                    )}
                  >
                    {renderDepartment()}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item md={3} xs={12}>
                <Box display="flex">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={submitForm}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    <SearchIcon />
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={(e) => {
                      e.preventDefault();
                      resetForm({});
                    }}
                    disabled={isSubmitting}
                  >
                    Clear
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      />
    </div>
  );
}
